var intervaloImageset;
!(function () {
  "use strict";
  var e = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          e.Android() || e.BlackBerry() || e.iOS() || e.Opera() || e.Windows()
        );
      },
    },
    a = function (e) {
      var a = $(".main-nav > ul");
      a.find("li").removeClass("active"),
        a.each(function () {
          $(this)
            .find('a[data-nav-section="' + e + '"]')
            .closest("li")
            .addClass("active");
        });
    };
  $(function () {
    var t;
    e.any() ||
      ($(".js-fullheight").css("height", $(window).height() - 160),
      $(window).resize(function () {
        $(".js-fullheight").css("height", $(window).height() - 160);
      })),
      $(".crystal").click(function (e) {
        var a = $(".microwindow");
        a.is(e.target) ||
          0 !== a.has(e.target).length ||
          ($(".crystal").hasClass("active") &&
            ($(".crystal").removeClass("active"),
            $(".crystal").animate({ opacity: "0" }, 350, function () {
              $(".crystal").css({ display: "none" }),
                $(".microwindow .tohide").hide(),
                $("body #initial").show(),
                clearInterval(intervaloImageset);
            })));
      }),
      $(".header-fixed").css("padding-top", $(".ltt-nav").height()),
      $(".filters-accordion span").on("click", function (e) {
        var a = $(this);
        a
          .closest(".filters-accordion")
          .find("div")
          .slideToggle(200, "easeInOutExpo"),
          a.hasClass("active") ? a.removeClass("active") : a.addClass("active"),
          e.preventDefault();
      }),
      $("pregunta span").on("click", function (e) {
        var a = $(this);
        a
          .closest("pregunta")
          .find("respuesta")
          .slideToggle(200, "easeInOutExpo"),
          a.parent().hasClass("active")
            ? a.parent().removeClass("active")
            : a.parent().addClass("active"),
          e.preventDefault();
      }),
      $(".faqmenu0 a,.faqmenu1 a").on("click", function (e) {
        var a = $(this).attr("data-section");
        $("html, body").animate(
          {
            scrollTop:
              $('.preguntas [data-section="' + a + '"]').offset().top - 120,
          },
          800,
          "easeInOutExpo"
        ),
          e.preventDefault();
      }),
      $(".browniebox ul li a").on("click", function (e) {
        var a = $(this).attr("data-pregunta");
        $("html, body").animate(
          {
            scrollTop:
              $('.preguntas [data-pregunta="' + a + '"]').offset().top - 90,
          },
          800,
          "easeInOutExpo"
        ),
          $('.preguntas [data-pregunta="' + a + '"]')
            .find("span")
            .click(),
          e.preventDefault();
      }),
      $("#gotophome").on("click", function (e) {
        return (
          $("html, body").animate({ scrollTop: 0 }, 800, "easeInOutExpo"),
          e.preventDefault(),
          !1
        );
      }),
      /**
      (function () {
        $("body").prepend('<div id="ltt-offcanvas" />'),
          $("body").prepend(
            '<a href="#" class="js-ltt-nav-toggle ltt-nav-toggle"><i></i></a>'
          );
        var e = $(".menu-1 > ul").clone();
        $("#ltt-offcanvas").append(e);
        var a = $(".menu-2 > ul").clone();
        $("#ltt-offcanvas").append(a),
          $("#ltt-offcanvas .has-dropdown").addClass("offcanvas-has-dropdown"),
          $("#ltt-offcanvas").find("li").removeClass("has-dropdown"),
          $(".offcanvas-has-dropdown")
            .mouseenter(function () {
              $(this)
                .addClass("active")
                .find("ul")
                .slideDown(500, "easeOutExpo");
            })
            .mouseleave(function () {
              $(this)
                .removeClass("active")
                .find("ul")
                .slideUp(500, "easeOutExpo");
            }),
          $(window).resize(function () {
            $("body").hasClass("offcanvas") &&
              ($("body").removeClass("offcanvas"),
              $(".js-ltt-nav-toggle").removeClass("active"));
          });
      })(),
      $("body").on("click", ".js-ltt-nav-toggle", function (e) {
        var a = $(this);
        $("body").hasClass("offcanvas")
          ? $("body").removeClass("offcanvas")
          : $("body").addClass("offcanvas"),
          a.toggleClass("active"),
          e.preventDefault();
      }),
      $("body").on("click", "#open-cart", function (e) {
        var a = $(this);
        $(".carrito").toggleClass("active"),
          a.toggleClass("active"),
          $("body").removeClass("offcanvas"),
          $(".js-ltt-nav-toggle").removeClass("active"),
          e.preventDefault();
      }),
      $("body").on("click", ".carrito-header span", function (e) {
        $(this),
          $(".carrito").toggleClass("active"),
          $(".main-ul #open-cart").removeClass("active"),
          e.preventDefault();
      }),
      */
      (t = $("div[data-section]")).waypoint(
        function (e) {
          "down" === e && a($(this.element).data("section"));
        },
        { offset: "150px" }
      ),
      t.waypoint(
        function (e) {
          "up" === e && a($(this.element).data("section"));
        },
        {
          offset: function () {
            return -$(this.element).height();
          },
        }
      ),
      $(".animate-box").waypoint(
        function (e) {
          "down" !== e ||
            $(this.element).hasClass("animated-fast") ||
            ($(this.element).addClass("item-animate"),
            setTimeout(function () {
              $("body .animate-box.item-animate").each(function (e) {
                var a = $(this);
                setTimeout(
                  function () {
                    var e = a.data("animate-effect");
                    "fadeIn" === e
                      ? a.addClass("fadeIn animated-fast")
                      : "fadeInLeft" === e
                      ? a.addClass("fadeInLeft animated-fast")
                      : "fadeInRight" === e
                      ? a.addClass("fadeInRight animated-fast")
                      : a.addClass("fadeInUp animated-fast"),
                      a.removeClass("item-animate");
                  },
                  100 * e,
                  "easeInOutExpo"
                );
              });
            }, 100));
        },
        { offset: "85%" }
      ),
      $(".has-dropdown")
        .mouseenter(function () {
          $(this)
            .find(".dropdown")
            .css("display", "block")
            .addClass("animated-fast fadeInUpMenu");
        })
        .mouseleave(function () {
          $(this)
            .find(".dropdown")
            .css("display", "none")
            .removeClass("animated-fast fadeInUpMenu");
        }),
      $(".js-gotop").on("click", function (e) {
        return (
          e.preventDefault(),
          $("html, body").animate(
            { scrollTop: $("html").offset().top },
            500,
            "easeInOutExpo"
          ),
          !1
        );
      }),
      $(window).scroll(function () {
        $(window).scrollTop() > 1
          ? $(".ltt-nav,.w100,body").addClass("active")
          : $(".ltt-nav,.w100,body").removeClass("active");
      }),
      $(".ltt-loader").fadeOut("slow"),
      $(".counters").length > 0 &&
        $(".counters").waypoint(
          function (e) {
            "down" !== e ||
              $(this.element).hasClass("animated") ||
              $(this.element).addClass("animated");
          },
          { offset: "90%" }
        ),
      $("#ltt-hero .flexslider").flexslider({
        animation: "fade",
        animationSpeed: 200,
        slideshowSpeed: 3500,
        directionNav: !0,
        controlNav: !1,
        start: function () {
          setTimeout(function () {
            $(".img-slide").removeClass("animated fadeInUp"),
              $(".flex-active-slide")
                .find(".img-slide")
                .addClass("animated fadeInUp"),
              $(".flexslider h1").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find("h1")
                .addClass("animated fadeInLeft"),
              $(".flexslider p").removeClass("animated fadeInLeft"),
              $(".flex-active-slide").find("p").addClass("animated fadeInLeft"),
              $(".left-top").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find(".left-top")
                .addClass("animated fadeInLeft"),
              $(".right-top").removeClass("animated fadeInRight"),
              $(".flex-active-slide")
                .find(".right-top")
                .addClass("animated fadeInRight"),
              $(".middle-middle").removeClass("animated fadeIn"),
              $(".flex-active-slide")
                .find(".middle-middle")
                .addClass("animated fadeIn"),
              $(".left-middle").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find(".left-middle")
                .addClass("animated fadeInLeft"),
              $(".right-middle").removeClass("animated fadeInRight"),
              $(".flex-active-slide")
                .find(".right-middle")
                .addClass("animated fadeInRight");
          }, 100);
        },
        before: function () {
          setTimeout(function () {
            $(".img-slide").removeClass("animated fadeInUp"),
              $(".flex-active-slide")
                .find(".img-slide")
                .addClass("animated fadeInUp"),
              $(".flexslider h1").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find("h1")
                .addClass("animated fadeInLeft"),
              $(".flexslider p").removeClass("animated fadeInLeft"),
              $(".flex-active-slide").find("p").addClass("animated fadeInLeft"),
              $(".left-top").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find(".left-top")
                .addClass("animated fadeInLeft"),
              $(".right-top").removeClass("animated fadeInRight"),
              $(".flex-active-slide")
                .find(".right-top")
                .addClass("animated fadeInRight"),
              $(".middle-middle").removeClass("animated fadeIn"),
              $(".flex-active-slide")
                .find(".middle-middle")
                .addClass("animated fadeIn"),
              $(".left-middle").removeClass("animated fadeInLeft"),
              $(".flex-active-slide")
                .find(".left-middle")
                .addClass("animated fadeInLeft"),
              $(".right-middle").removeClass("animated fadeInRight"),
              $(".flex-active-slide")
                .find(".right-middle")
                .addClass("animated fadeInRight");
          }, 100);
        },
      }),
      $(".slick-productos").slick({
        dots: !1,
        arrows: !0,
        autoplay: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1099,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
          },
          { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 530, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      }),
      $(".slick-productos2").length &&
        $(".slick-productos2").slick({
          dots: !1,
          arrows: !0,
          autoplay: !1,
          infinite: !1,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        }),
      $(".slick-resena").slick({
        dots: !1,
        arrows: !0,
        autoplay: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1099,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
          },
          { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 690, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
  });
})(),
  $(document).ready(function () {
    null != navigator.userAgent.match(/iPad|iPhone|iPod/i) &&
      $("body").addClass("ipad"),
      $(".micrologo").on("click", function (e) {
        e.preventDefault(),
          $(".crystal").animate({ opacity: "0" }, 350, function () {
            $(".crystal").css({ display: "none" }).removeClass("active"),
              $(".microwindow .tohide").hide(),
              $("body #initial").show(),
              clearInterval(intervaloImageset);
          });
      }),
      $(".inputfield label").on("click", function (e) {
        $(this).parent().find("input,textarea").focus(), e.preventDefault();
      }),
      $("body").on("click", "a.review", function (e) {
        $("#review.crystal").css({ display: "block" }).addClass("active"),
          $("#review.crystal").animate({ opacity: "1" }, 350, function () {}),
          $("#review.crystal #idproductoinpedido").val(
            $(this).attr("data-idproductoinpedido")
          ),
          e.preventDefault();
      }),
      $("body").on("click", "a.modificar", function (e) {
        $("#modificar.crystal").css({ display: "block" }).addClass("active"),
          $("#modificar.crystal").animate(
            { opacity: "1" },
            350,
            function () {}
          ),
          e.preventDefault();
      }),
      $("body").on("click", "a.ayuda", function (e) {
        $("#ayuda.crystal").css({ display: "block" }).addClass("active"),
          $("#ayuda.crystal").animate({ opacity: "1" }, 350, function () {}),
          e.preventDefault();
      }),
      $("body").on("click", "a.update-info", function (e) {
        var a = $(this).attr("id");
        $(".microwindow .tohide").hide(),
          console.log(a),
          $("[data-show='" + a + "']").show(),
          e.preventDefault();
      }),
      $("#stars li")
        .on("mouseover", function () {
          var e = parseInt($(this).data("value"), 10);
          $(this)
            .parent()
            .children("li.star")
            .each(function (a) {
              a < e ? $(this).addClass("hover") : $(this).removeClass("hover");
            });
        })
        .on("mouseout", function () {
          $(this)
            .parent()
            .children("li.star")
            .each(function (e) {
              $(this).removeClass("hover");
            });
        }),
      $("#stars li").on("click", function () {
        var e = parseInt($(this).data("value"), 10),
          t = $(this).parent().children("li.star");
        for (a = 0; a < t.length; a++) $(t[a]).removeClass("selected");
        for (a = 0; a < e; a++) $(t[a]).addClass("selected");
        var s = parseInt($("#stars li.selected").last().data("value"), 10);
        $("#rankstars").val(s);
      }),
      $(".buscador input[type=radio],.buscador input[type=checkbox]").on(
        "change",
        function () {
          $(this).closest("form").submit();
        }
      ),
      $(".buscador input[type=reset]").on("click", function () {
        $(":input", ".buscador")
          .not(":button, :submit, :reset, :hidden")
          .val("")
          .removeAttr("checked")
          .removeAttr("selected");
        var e = new Date(),
          a = ("0" + e.getDate()).slice(-2),
          t = ("0" + (e.getMonth() + 1)).slice(-2),
          s = e.getFullYear() + "-" + t + "-" + a;
        $("input[type=date]").val(s), $(this).closest("form").submit();
      });
    var e, a, t, s, i, n, o;
    for (
      $.ajax({
        url: "https://api.instagram.com/v1/users/self/media/recent",
        dataType: "jsonp",
        type: "GET",
        data: {
          access_token: "10924641859.1677ed0.86682e1a13704240a0e3990d2f397695",
          count: 5,
        },
        success: function (a) {
          for (e in a.data)
            $("#instafeed").append(
              '<li><span><img src="' +
                a.data[e].images.low_resolution.url +
                '"></span></li>'
            );
          $("#instafeed").slick({
            dots: !1,
            arrows: !0,
            autoplay: !1,
            infinite: !1,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1099,
                settings: { slidesToShow: 3, slidesToScroll: 1 },
              },
              {
                breakpoint: 992,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
              },
              {
                breakpoint: 530,
                settings: { slidesToShow: 1, slidesToScroll: 1 },
              },
            ],
          });
        },
        error: function (e) {
          // TODO: this is a uncontrolled error
          // console.log(e);
        },
      }),
        $(".productozoom img")
          .wrap('<span style="display:inline-block"></span>')
          .css("display", "block")
          .parent()
          .zoom({ url: $(this).attr("src") }),
        $(".slider-for").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: !1,
          cssEase: "linear",
          adaptiveHeight: !0,
          asNavFor: "#bx-pager",
          draggable: !1,
          swipe: !1,
          swipeToSlide: !1,
        }),
        $("#bx-pager").slick({
          dots: !1,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: !1,
          infinite: !0,
          arrows: !0,
          asNavFor: ".slider-for",
          centerMode: !1,
          focusOnSelect: !0,
          vertical: !0,
        }),
        e = document.getElementsByClassName("custom-select"),
        a = 0;
      a < e.length;
      a++
    ) {
      for (
        s = e[a].getElementsByTagName("select")[0],
          (i = document.createElement("DIV")).setAttribute(
            "class",
            "select-selected"
          ),
          i.innerHTML = s.options[s.selectedIndex].innerHTML,
          e[a].appendChild(i),
          (n = document.createElement("DIV")).setAttribute(
            "class",
            "select-items select-hide"
          ),
          t = 1;
        t < s.length;
        t++
      )
        ((o = document.createElement("DIV")).innerHTML =
          s.options[t].innerHTML),
          o.addEventListener("click", function (e) {
            var a, t, s, i, n;
            for (
              i = this.parentNode.parentNode.getElementsByTagName("select")[0],
                n = this.parentNode.previousSibling,
                t = 0;
              t < i.length;
              t++
            )
              if (i.options[t].innerHTML == this.innerHTML) {
                for (
                  i.selectedIndex = t,
                    n.innerHTML = this.innerHTML,
                    a = this.parentNode.getElementsByClassName(
                      "same-as-selected"
                    ),
                    s = 0;
                  s < a.length;
                  s++
                )
                  a[s].removeAttribute("class");
                this.setAttribute("class", "same-as-selected");
                break;
              }
            n.click();
          }),
          n.appendChild(o);
      e[a].appendChild(n),
        i.addEventListener("click", function (e) {
          e.stopPropagation(),
            l(this),
            this.nextSibling.classList.toggle("select-hide"),
            this.classList.toggle("select-arrow-active");
        });
    }
      
    $(".slider-for-announcement").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !1,
      cssEase: "linear",
      adaptiveHeight: !0,
      autoplay: !0,
      autoplaysSpeed: 5000,
      swipe: !1,
      swipeToSlide: !1,
    })

    function l(e) {
      var a,
        t,
        s,
        i = [];
      for (
        a = document.getElementsByClassName("select-items"),
          t = document.getElementsByClassName("select-selected"),
          s = 0;
        s < t.length;
        s++
      )
        e == t[s] ? i.push(s) : t[s].classList.remove("select-arrow-active");
      for (s = 0; s < a.length; s++)
        i.indexOf(s) && a[s].classList.add("select-hide");
    }
    document.addEventListener("click", l);
  });
